import { useQuery } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
import { CustomFieldObj } from "../types/custom-fields";

const useGetUsersTags = (isCustomTagsEnabled: boolean) => {
  return useQuery(
    ["usersTags"],
    () => servicesUtils.getService<CustomFieldObj[]>(`/tags/`),
    {
      enabled: isCustomTagsEnabled,
    }
  );
};

export default useGetUsersTags;
